import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos() {
        return axiosJwt.get(`${api}/controleacesso/fornecedores/usuarios`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        return axiosJwt.get(`${api}/controleacesso/fornecedores/usuarios/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ativarDesativarUsuario(usuarioId) {
        return axiosJwt.patch(`${api}/controleacesso/fornecedores/usuarios/${usuarioId}/ativardesativar`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    resetarSenhaUsuario(usuarioId) {
        return axiosJwt.patch(`${api}/controleacesso/fornecedores/usuarios/${usuarioId}/resetarsenha`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirUsuario(usuario) {
        return axiosJwt.post(`${api}/controleacesso/fornecedores/usuarios`, usuario)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarUsuario(usuario) {
        return axiosJwt.put(`${api}/controleacesso/fornecedores/usuarios`, usuario)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    associarPerfisAcesso(usuarioPerfisAcesso) {
        return axiosJwt.post(`${api}/controleacesso/fornecedores/usuarios/perfisacesso/associar`, usuarioPerfisAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarPerfilAcesso(usuarioPerfilAcesso) {
        return axiosJwt.post(`${api}/controleacesso/fornecedores/usuarios/perfilacesso/desassociar`, usuarioPerfilAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarPerfisAcesso(usuarioPerfisAcesso) {
        return axiosJwt.post(`${api}/controleacesso/fornecedores/usuarios/perfisacesso/desassociar`, usuarioPerfisAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
}
